'use strict';

var _ = require('lodash');
function FareAnalysisPanelController($scope, dataRetrieverService) {
  var MAX_SELECTED_CLASSES = 5;
  function getSelectedClasses(brushFilter) {
    return _.get(brushFilter, 'filterArguments[0][0].classes');
  }
  function hasSelectedClasses(brushFilter) {
    var selectedClasses = getSelectedClasses(brushFilter);
    return selectedClasses && selectedClasses.length;
  }
  function isLimitedClassSelection(brushFilter) {
    var selectedClassesCount = hasSelectedClasses(brushFilter);
    return selectedClassesCount && selectedClassesCount <= MAX_SELECTED_CLASSES;
  }
  $scope.updateBrushes = function (brushFilter) {
    if (brushFilter.filterType === 'class-usage') {
      $scope.screenState.brushFilters = {};
    }
    if (!brushFilter.isEmpty()) {
      $scope.screenState.brushFilters[brushFilter.filterType] = brushFilter;
    } else {
      delete $scope.screenState.brushFilters[brushFilter.filterType];
    }
    dataRetrieverService.setBrushFilters($scope.screenState.brushFilters, $scope.screen);
  };
  $scope.isHideAverageFareGrid = function () {
    return $scope.screenState.isFBCodeGridVisible && $scope.screenState.isFBGroupGridVisible;
  };
  $scope.isRegularFlow = function () {
    return $scope.screenState.averageFaresGridState.selectedFlowType === 'REGULAR';
  };
  $scope.updateGridVisibility = function (brushFilter) {
    var classesSelected = !!hasSelectedClasses(brushFilter);
    if (brushFilter.filterType === 'fbcs-grid') {
      if ($scope.isRegularFlow()) {
        $scope.screenState.isFBGroupGridVisible = classesSelected;
        if (!$scope.screenState.isFBGroupGridVisible) {
          $scope.screenState.isFBCodeGridVisible = false;
        }
      } else {
        $scope.screenState.isFBCodeGridVisible = classesSelected;
        $scope.screenState.isFBGroupGridVisible = false;
      }
      $scope.$broadcast('grid:loadData:contributing-services');
      $scope.$broadcast('grid:contributing-fbgs:reload-data');
    }
    if (brushFilter.filterType === 'fbgs-grid') {
      $scope.screenState.isFBCodeGridVisible = classesSelected;
      $scope.$broadcast('grid:loadData:contributing-fbcs');
    }
  };
  $scope.brushWithApply = function (brushFilter) {
    $scope.updateBrushes(brushFilter);
    if (brushFilter.filterType === 'class-usage') {
      $scope.screenState.isFBCUsageChartVisible = isLimitedClassSelection(brushFilter);
      $scope.screenState.isFBCApplicabilityChartVisible = isLimitedClassSelection(brushFilter);
      $scope.$broadcast('brush-filter:filterApplied', brushFilter);
    }
    $scope.updateGridVisibility(brushFilter);
    $scope.$apply();
  };
  $scope.debouncedBrush = _.debounce($scope.brushWithApply, 50);
}
FareAnalysisPanelController.$inject = ['$scope', 'DataRetrieverService'];
module.exports = FareAnalysisPanelController;